export const dashboardTranslations = {
  ru: {
    common: {
      dashboard: "Панель управления",
      overview: "Обзор",
      statistics: "Статистика",
      reports: "Отчеты",
      analytics: "Аналитика"
    },
    metrics: {
      occupancy: "Загрузка",
      revenue: "Доход",
      adr: "Средняя цена",
      revpar: "Доход на номер"
    },
    layout: {
      sidebarCollapse: "Свернуть боковую панель",
      sidebarExpand: "Развернуть боковую панель",
      sidebarCollapsed: "Боковая панель свернута",
      sidebarExpanded: "Боковая панель развернута"
    },
    topBar: {
      welcome: "Добро пожаловать",
      profile: "Профиль",
      settings: "Настройки",
      logout: "Выйти",
      search: "Поиск...",
      hotelNotSelected: "Отель не выбран",
      roomGrid: "Шахматка",
      lite: "Lite",
      bookingsList: "Заказы",
      subscriptionExpired: "Подписка истекла"
    }
  },
  en: {
    common: {
      dashboard: "Dashboard",
      overview: "Overview",
      statistics: "Statistics",
      reports: "Reports",
      analytics: "Analytics"
    },
    metrics: {
      occupancy: "Occupancy",
      revenue: "Revenue",
      adr: "Average Daily Rate",
      revpar: "Revenue per Available Room"
    },
    layout: {
      sidebarCollapse: "Collapse sidebar",
      sidebarExpand: "Expand sidebar",
      sidebarCollapsed: "Sidebar collapsed",
      sidebarExpanded: "Sidebar expanded"
    },
    topBar: {
      welcome: "Welcome",
      profile: "Profile",
      settings: "Settings",
      logout: "Logout",
      search: "Search...",
      hotelNotSelected: "Hotel not selected",
      roomGrid: "Room Grid",
      lite: "Lite",
      bookingsList: "Orders",
      subscriptionExpired: "Subscription expired"
    }
  }
};

export default dashboardTranslations;